const brandingFields = [
  {
    key: 'defaultShowPlayerPictureOnWebsite',
    type: 'boolean',
    templateOptions: {
      label: 'defaultShowPlayerPictureOnWebsite'
    }
  },
  {
    key: 'websiteDefaultTheme',
    type: 'ntm-select',
    isString: true,
    options: ['DARK', 'LIGHT'],
    templateOptions: {
      label: 'websiteDefaultTheme',
      translated: true
    }
  },
  {
    key: 'allowWebsiteThemeChange',
    type: 'boolean',
    templateOptions: {
      label: 'allowWebsiteThemeChange'
    }
  },
  {
    key: 'hasWebsiteGdprConsent',
    type: 'boolean',
    templateOptions: {
      label: 'hasWebsiteGdprConsent'
    }
  },
  {
    key: 'facebookUrl',
    type: 'input',
    templateOptions: {
      label: 'fb'
    }
  },
  {
    key: 'twitterUrl',
    type: 'input',
    templateOptions: {
      label: 'tw'
    }
  },
  {
    key: 'instagramUrl',
    type: 'input',
    templateOptions: {
      label: 'insta'
    }
  },
  {
    key: 'pinterestUrl',
    type: 'input',
    templateOptions: {
      label: 'pin'
    }
  },
  {
    key: 'youtubeUrl',
    type: 'input',
    templateOptions: {
      label: 'yt'
    }
  },
  {
    key: 'tiktokUrl',
    type: 'input',
    templateOptions: {
      label: 'tiktok'
    }
  },
  {
    key: 'vkUrl',
    type: 'input',
    templateOptions: {
      label: 'vk'
    }
  },
  {
    key: 'colorButton',
    type: 'linear-color',
    templateOptions: {
      label: 'colorButton'
    }
  },
  {
    key: 'color1',
    type: 'color',
    templateOptions: {
      label: 'color1'
    }
  },
  {
    key: 'color2',
    type: 'color',
    templateOptions: {
      label: 'color2'
    }
  },
  {
    key: 'color3',
    type: 'color',
    templateOptions: {
      label: 'color3'
    }
  },
  {
    key: 'color4',
    type: 'color',
    templateOptions: {
      label: 'color4'
    }
  },
  {
    key: 'color5',
    type: 'color',
    templateOptions: {
      label: 'color5'
    }
  },
  {
    key: 'multi_league_select_title',
    type: 'input',
    templateOptions: {
      label: 'multi_league_select_title'
    }
  }
]

const organizationFields = [
  {
    key: 'title',
    type: 'input',
    templateOptions: {
      label: 'title'
    }
  },
  {
    key: 'email',
    type: 'input',
    templateOptions: {
      inputType: 'email',
      label: 'email'
    }
  },
  {
    key: 'phone',
    type: 'input',
    templateOptions: {
      label: 'phone'
    }
  },
  {
    key: 'address',
    type: 'input',
    templateOptions: {
      label: 'address'
    }
  },
  {
    key: 'postalCode',
    type: 'input',
    templateOptions: {
      label: 'postalCode'
    }
  },
  {
    key: 'lang',
    type: 'ntm-select',
    isString: true,
    options: [],
    templateOptions: {
      translationObject: 'languages',
      label: 'lang',
      translated: true
    }
  },
  {
    key: 'availableWebsiteLanguages',
    type: 'ntm-select',
    isString: true,
    multiple: true,
    options: [],
    templateOptions: {
      translationObject: 'languages',
      label: 'availableWebsiteLanguages',
      translated: true
    }
  },
  {
    key: 'timezone',
    type: 'ntm-select',

    isString: true,
    options: [],
    templateOptions: {
      label: 'timezone'
    }
  },
  {
    key: 'formatOfDate',
    type: 'ntm-select',

    isString: true,
    options: ['DMY', 'MDY', 'YMD'],
    templateOptions: {
      translated: true,
      label: 'formatOfDate'
    }
  },
  {
    key: 'formatOfTime',
    type: 'ntm-select',

    isString: true,
    options: ['12h-clock', '24h-clock'],
    templateOptions: {
      label: 'formatOfTime',
      translated: true
    }
  },
  {
    key: 'personNameFormat',
    type: 'ntm-select',
    isString: true,
    options: ['FIRST_NAME_FIRST', 'LAST_NAME_FIRST'],
    templateOptions: {
      label: 'personNameFormat',
      translated: true
    }
  }
]

const defaultsFields = [
  {
    key: 'has_substitutions',
    type: 'boolean',
    templateOptions: {
      label: 'has_substitutions'
    }
  },
  {
    key: 'show_player_in_game_time_on_website',
    type: 'boolean',
    templateOptions: {
      label: 'show_player_in_game_time_on_website'
    }
  },
  {
    key: 'show_player_plus_minus_on_website',
    type: 'boolean',
    templateOptions: {
      label: 'show_player_plus_minus_on_website'
    }
  },
  {
    key: 'number_of_regular_periods',
    type: 'input',
    templateOptions: {
      inputType: 'number',
      label: 'number_of_regular_periods'
    }
  },
  {
    key: 'period_time',
    type: 'input',
    templateOptions: {
      inputType: 'number',
      label: 'periodTime'
    }
  },
  {
    key: 'overtime_period_time',
    type: 'input',
    templateOptions: {
      inputType: 'number',
      label: 'overtimePeriodTime'
    }
  }
]

const dataFields = [
  {
    key: 'shortDescription',
    type: 'input',
    templateOptions: {
      label: 'shortDescription'
    }
  },
  {
    key: 'metaKeywords',
    type: 'input',
    templateOptions: {
      label: 'metaKeywords'
    }
  },
  {
    key: 'metaTitle',
    type: 'input',
    templateOptions: {
      label: 'metaTitle'
    }
  },
  {
    key: 'metaDescription',
    type: 'input',
    templateOptions: {
      label: 'metaDescription'
    }
  },
  {
    key: 'metaCononical',
    type: 'input',
    templateOptions: {
      label: 'metaCononical'
    }
  },
  {
    key: 'hasMetaNoindex',
    type: 'boolean',
    templateOptions: {
      label: 'hasMetaNoindex'
    }
  },
  {
    key: 'googleAnalyticsId',
    type: 'input',
    templateOptions: {
      label: 'googleAnalyticsId'
    }
  }
]

const livestreamFields = [
  {
    key: 'livestream_play_by_play_delay_in_seconds',
    type: 'input',
    templateOptions: {
      label: 'livestream_play_by_play_delay_in_seconds',
      inputType: 'number'
    }
  },
  {
    key: 'show_league_engine_logo_to_livestream',
    type: 'boolean',
    templateOptions: {
      label: 'show_league_engine_logo_to_livestream'
    }
  }
]

export default { brandingFields, organizationFields, dataFields, livestreamFields, defaultsFields }
